import { dayjs } from '@shared/utils';

import { type ExamEventCourse, type ExamEventSession } from '../../types';

export function mapExamCourseTimeExtensionItems(
  examEventCourses: ExamEventCourse[],
  examStartDate: Date,
  currentSession?: ExamEventSession,
  now = new Date(),
) {
  return [...examEventCourses]
    .map((examEventCourse) => {
      const currentExamDurationSession =
        examEventCourse.metadata?.settings.examDuration?.sessions.find(
          (session) => session.order === currentSession?.round,
        );

      const sessionTimeAdjustment = examEventCourse.metadata?.sessionTimeAdjustments?.find(
        (adjustment) => adjustment.sessionId === currentSession?.id,
      );

      const endTime = dayjs(examStartDate)
        .add(currentExamDurationSession?.value ?? 0, 'seconds')
        .toDate();

      const isInProgress = dayjs(now).isBetween(examStartDate, endTime, null, '[]');

      return {
        id: examEventCourse.id,
        code: examEventCourse.examCourse?.code ?? '',
        duration: currentExamDurationSession?.value ?? 0,
        endTime,
        maxExtendableDurationInMs: sessionTimeAdjustment?.maxExtendableDurationInMs ?? 0,
        isInProgress,
        isDisabled: !currentSession || !currentExamDurationSession || !isInProgress,
      };
    })
    .sort((a, b) => b.endTime.getTime() - a.endTime.getTime());
}
